




















































// Vue
import { defineComponent, PropType } from '@vue/composition-api'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'
import { Button, Icon } from '@/components/general'

// Models
import { Paginator } from '@/models'
import { BondType } from '@/models/config'

export default defineComponent({
  name: 'BondTypesTableList',
  components: {
    DataTable,
    IsActive,
    Button,
    Icon
  },
  props: {
    items: {
      type: Array as PropType<BondType[]>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object as PropType<Paginator>,
      default: () => ({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
      })
    },
    changePage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    },
    changePerPage: {
      type: Function as PropType<() => void>,
      default: () => (null)
    }
  },
  setup () {
    const fields = [
      {
        key: 'code',
        sortable: true,
        label: 'Código'
      },
      {
        key: 'name',
        sortable: true,
        label: 'Descripción'
      },
      {
        key: 'is_massive',
        sortable: false,
        label: 'Carga Masiva',
        formatter: (value) => value ? 'SI' : 'No'
      },
      {
        key: 'amount_fortnight',
        sortable: true,
        label: 'Importe Quincenal',
        formatter: (value) => `S/ ${value}`
      },
      {
        key: 'status_text',
        sortable: true,
        label: 'Status'
      },
      {
        key: 'actions',
        sortable: false,
        label: '',
        thClass: 'one-line w-30',
        thStyle: {
          width: '15%'
        }
      }
    ]
    return {
      fields
    }
  }
})
